const useButtonClass = () => {
  const color = inject('color')

  let buttonClass = 'is-lessmess-app has-text-primary'
  if (color === 'orange') {
    buttonClass = 'is-lessmess-desk'
  }
  return buttonClass
}

export default useButtonClass
